// ANGULAR MODULE
import { provideHttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
// THIRD PARTY MODULE
import { CountdownModule } from 'ngx-countdown';
import { LOAD_WASM, NgxScannerQrcodeModule } from 'ngx-scanner-qrcode';
import { MessageService } from 'primeng/api';
import { InputNumberModule } from 'primeng/inputnumber';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectModule } from 'primeng/select';
import { ToastModule } from 'primeng/toast';

import { TranslateModule } from '@ngx-translate/core';
import { TranslationModule } from './translation/translation.module';

// WALLET ACCOUNT SHARED MODULE
// import { PaperOtpModule } from './shared/paper-otp/paper-otp.module';
import { PaperOtpModule } from './shared/paper-otp/paper-otp.module';
import { PaperCurrencyModule } from './shared/pipes/paper-currency/paper-currency.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';


// WALLET ACCOUNT SHARED COMPONENT
import { AccessDeniedComponent } from './shared/access-denied/access-denied.component';


// WALLET ACCOUNT CORE
import { walletQrisModuleProvider } from './core/helpers/provider/module/fs-module.provider';
import { WalletQrisCoreModule } from './core/wallet-qris-core.module';
import { WalletQrisDetailComponent } from './pages/wallet-qris-detail/wallet-qris-detail.component';
import { WalletQrisInterfaceComponent } from './pages/wallet-qris-interface/wallet-qris-interface.component';
import { WalletQrisTrxPinComponent } from './pages/wallet-qris-trx-pin/wallet-qris-trx-pin.component';
import { WalletQrisTrxStatusComponent } from './pages/wallet-qris-trx-status/wallet-qris-trx-status.component';


declare global {
  interface Window {
    AppChannel?: any;
  }
}

LOAD_WASM().subscribe();

@NgModule({
  declarations: [
    AppComponent,
    AccessDeniedComponent,
    WalletQrisInterfaceComponent,
    WalletQrisDetailComponent,
    WalletQrisTrxPinComponent,
    WalletQrisTrxStatusComponent

  ],
  imports: [
    TranslationModule,
    TranslateModule,
    BrowserModule,
    AppRoutingModule,
    WalletQrisCoreModule.forRoot(),
    BrowserModule,
    FormsModule,
    // PaperOtpModule,
    MessagesModule,
    ProgressSpinnerModule,
    SelectModule,
    InputNumberModule,
    CountdownModule,
    ToastModule,
    NgxScannerQrcodeModule,
    PaperCurrencyModule,
    PaperOtpModule
  ],
  providers: [...walletQrisModuleProvider, MessageService, provideHttpClient(), provideAnimations()],
  bootstrap: [AppComponent],
})
export class AppModule {}
